import { useQuery } from "@tanstack/react-query";
import { adminApi } from "../../../api-client";
import type { ActivityPeriod } from "../../../schemas/activity";
import { queryKeys } from "../../query-keys";

/** Active users split by surface for day/week/month dashboard cards. */
export function useActivityRollup(period: ActivityPeriod) {
	return useQuery({
		queryFn: () => adminApi.activity.rollup(period),
		queryKey: queryKeys.activityRollup.period(period),
	});
}

const LOG_PAGE_SIZE = 20;

/** Newest product-action rows for the admin activity log. */
export function useActivityEvents(limit = LOG_PAGE_SIZE, offset = 0) {
	return useQuery({
		queryFn: () => adminApi.activity.events(limit, offset),
		queryKey: queryKeys.activityEvents.list(limit, offset),
	});
}

/** Daily product-action + unique-user counts for the admin chart. */
export function useActivitySeries(days: number) {
	return useQuery({
		queryFn: () => adminApi.activity.series(days),
		queryKey: queryKeys.activitySeries.range(days),
	});
}
